import { render, staticRenderFns } from "./NotaEvolucionMedica.vue?vue&type=template&id=570f51bf&scoped=true&"
import script from "./NotaEvolucionMedica.vue?vue&type=script&lang=js&"
export * from "./NotaEvolucionMedica.vue?vue&type=script&lang=js&"
import style0 from "./NotaEvolucionMedica.vue?vue&type=style&index=0&id=570f51bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570f51bf",
  null
  
)

export default component.exports